import React from "react"
import { connect } from 'react-redux';
import SignInForm from "../views/SignInForm";
import {userActions} from "../../actions/UserActions";
import {formActions} from "../../actions/FormActions";

class SignInFormContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: ''
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const {name, value} = e.target;
        this.setState({[name]: value});
    }

    handleSubmit(e) {
        e.preventDefault();

        const { username, password } = this.state;
        const { dispatch } = this.props;

        dispatch(formActions.loading());

        if (username && password) {
            dispatch(userActions.login(username, password));
        } else {
            dispatch(formActions.error("Заполните все поля"));
        }
    }

    render() {
        return (
            <SignInForm result={this.props.result} onChange={this.handleChange} onSubmit={this.handleSubmit} />
        );
    }
}

function mapStateToProps(store) {
    return {
        result: store.formReducer
    };
}

export default connect(mapStateToProps)(SignInFormContainer);